module.exports = __webpack_public_path__ + "media/boxes/exploding-box-c593129a.svg";